import {Backend} from '@common/backend'
import {globals} from '@extensions/globals-base'
import {
  BoardGuests,
  createDataObjectId,
  DataObjectId,
  disallowAllOnProject,
  GenResp,
  getDefaultProjectPermissions,
  getSharedBoardPermissions,
  Hub,
  PermissionsById
} from 'yougile-model'
import {Util} from 'yougile-util'
import {SharedBoardsClient} from './shared-boards-client'
import {sharedBoardsEvents} from './shared-boards-events'
import {Sync} from './sync'

export class SharedBoardsHelper {
  private static permissionRoleKey = createDataObjectId()
  private static updateIsRunning = false

  public static isShared(): boolean {
    return !!SharedBoardsClient.getId()
  }

  public static getBoard(): Hub {
    const companyId = SharedBoardsClient.companyId
    if (!companyId) {
      return undefined
    }
    const boardId = SharedBoardsClient.boardId
    const box = Sync.get({companyId})
    return box?.getHub(boardId)
  }

  public static getProject(): Hub {
    const companyId = SharedBoardsClient.companyId
    if (!companyId) {
      return undefined
    }
    const boardId = SharedBoardsClient.boardId
    const box = Sync.get({companyId})
    if (!box) {
      return undefined
    }
    const board = box.getHub(boardId)
    const projectId = board?.location
    return box.getHub(projectId)
  }

  public static getSharedRoleKey(projectId: DataObjectId): DataObjectId {
    const boardId = SharedBoardsClient.boardId
    if (!boardId) {
      return undefined
    }
    const box = Sync.getCurrentSandbox()
    if (!box) {
      return undefined
    }
    const board = box.getHub(boardId)
    return projectId === board?.location ? this.permissionRoleKey : undefined
  }

  public static getSharedRole(projectId: DataObjectId): PermissionsById {
    const boardId = SharedBoardsClient.boardId
    if (!boardId) {
      return undefined
    }
    const box = Sync.getCurrentSandbox()
    const type = SharedBoardsClient.settings.type
    const board = box.getHub(boardId)
    if (projectId !== board?.location) {
      return undefined
    }
    return {
      ...getSharedBoardPermissions(
        boardId,
        type,
        SharedBoardsClient.settings.allowedColumns
      ),
      [projectId]: {
        type: 'project',
        objectId: projectId,
        permissions: disallowAllOnProject(getDefaultProjectPermissions())
      }
    }
  }

  public static async updateGustsInfo(boardId: DataObjectId): Promise<void> {
    if (this.updateIsRunning) {
      while (this.updateIsRunning) {
        await Util.wait(1000)
      }
      return
    }
    this.updateIsRunning = true
    try {
      const guestId = SharedBoardsClient.getId()
      if (guestId) {
        const res = await SharedBoardsClient.requestCred()
        if (res.result === 'ok') {
          SharedBoardsClient.boardGuests = res.guests
          if (res.guest) {
            SharedBoardsClient.guest = res.guest
          }
        }
      } else {
        const res = await Backend.postJSON<{guests: BoardGuests} & GenResp>(
          '/data/shared-boards/board/list-guests',
          {...Backend.loadCred(), companyId: globals.getCompanyId(), boardId}
        )
        if (res.result === 'ok') {
          SharedBoardsClient.boardGuests = res.guests
          sharedBoardsEvents.trigger()
        }
      }
    } finally {
      this.updateIsRunning = false
    }
  }
}
